import Switch from '@material-ui/core/Switch'
import useTranslate from '../../../../i18n/useTranslate'
import useI18nPlayground from './useI18nPlayground'
import { useTranslation } from 'react-i18next'
type I18nPlaygroundViewType = ReturnType<typeof useI18nPlayground>
const I18nPlaygroundView = (props: I18nPlaygroundViewType) => {
    const { isTH, onClickChangeLang } = props
    const translate = useTranslate()
    return (
        <div>
            <h1>Language</h1>
            <div>
                EN
                <Switch checked={isTH} onChange={onClickChangeLang} name="language" />
                TH
            </div>
            <div>{translate.get('login.username')}</div>
        </div>
    )
}

const I18nPlayground = () => {
    const i18nPlaygroundModel = useI18nPlayground()
    return <I18nPlaygroundView {...i18nPlaygroundModel} />
}

export default I18nPlayground
